const version = "0.0.1"; // 系统版本
const timeout = 10000; // 请求超时
const baseType = true; //是否使用代理
const baseAPI = {
  development: "http://back.xianlingruan.com:8601", //测试环境
};
// 当前环境接口地址
const baseURL = baseAPI.development;
// 系统参数配置
export default {
  version, // 系统版本
  timeout, // 请求超时
  baseAPI, // 所有环境接口对象
  baseURL, // 当前环境接口地址
  baseType, //是否使用代理
};



// WEBPACK FOOTER //
// ./src/config/index.js